
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Medias from '@/@next/services/Medias'
import { QuestionCommentItem } from '@/@types/question'
import { MediaImage, MediaAudio, MediaVideo } from '@/@types/graphql'
import { CImage } from '@/@next/components/image'
import { CLoader } from '@/components/loader'

const config = {
  name: 'c-question-comment',
  components: {
    CImage,
    CLoader
  }
}

@Component(config)
export default class CQuestionComment extends Mixins(Medias) {

  @Prop({ type: Object }) comment!: QuestionCommentItem

  image: MediaImage | null = null

  async mounted () {
    if (this.imageId) this.image = await this.GET_SINGLE_IMAGE(this.imageId)
    this.$emit('ready')
  }

  get text () {
    // TODO : add target filter
    const body = this.comment.body.find((el: any) => el.language === this.$i18n.locale)
    if (!body) return this.comment.body[0]?.value.html || ''
    return body.value.html
  }

  get imageId () {
    // TODO : add target filter
    const { imageRefs } = this.comment
    const imageRef = imageRefs.find((el: any) => el.language === this.$i18n.locale)
    return imageRef ? imageRef.id : imageRefs[0]?.id || null
  }

}
